export const GF_UPDATE_STATE = "GF_UPDATE_STATE"
export const GF_MORE_FAQS_LOADED = "GF_MORE_FAQS_LOADED"
export const GF_FAQ_CREATED = "GF_FAQ_CREATED"
export const GF_FAQ_UPDATED = "GF_FAQ_UPDATED"
export const GF_FAQ_DELETED = "GF_FAQ_DELETED"
